'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var TabPanel = require('../components/TabPanel/TabPanel.js');

var HorizontalTabViews = function (_a) {
    var elements = _a.elements, value = _a.value;
    return (React__default.createElement(React__default.Fragment, null, elements.map(function (Element, i) { return (
    // eslint-disable-next-line react/no-array-index-key
    React__default.createElement(TabPanel, { key: "wrapped-tabpanel-" + i, index: i, value: value }, Element)); })));
};

module.exports = HorizontalTabViews;
